// Copyright (c) 2017 Deere & Company

import LaborRateDealers from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.laborRateDealers
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children, routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children,
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborRateDealers);



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/state-connector.js